import React from 'react';
import {
  CardMedia,
  Card,
  Typography,
  CardTitle,
  CardActions,
  Button
} from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import { useImpression } from '@thd-olt-component-react/impression';
import QuotesHeader from '../QuotesHeader';
import { nullStatePropTypes } from './nullStatePropTypes';

const CompactNullView = ({
  cardBody,
  cardTitle,
  imageAlt,
  imageUrl,
  learnMoreText,
  componentId
}) => {

  const { ref, clickID } = useImpression({
    data: {
      component: 'QuotesFallbackView',
      name: 'QuotesFallbackView',
      id: componentId,
      position: 1,
      type: 'content',
    }
  });

  return (
    <Card
      data-component="Quotes"
      data-testid="quotes-container"
      className="sui-h-full"
      CardContentProps={{
        className: classNames(
          'sui-flex-col',
          'sui-flex',
          'sui-gap-4',
          'sui-h-full',
          'sui-p-4',
          'sui-w-full'
        )
      }}
      ref={ref}
      clickid={clickID}
    >
      <QuotesHeader hideActionLink />
      <div
        className={
          classNames(
            '@3xl:sui-pr-8',
            '@7xl:sui-max-w-md',
            'sui-flex-col',
            'sui-flex',
            'sui-gap-4',
            'sui-h-full',
            'sui-overflow-hidden',
            'sui-pt-4'
          )
        }
      >
        <CardMedia
          src={imageUrl}
          alt={imageAlt}
          aspect="wide"
        />
        <div
          className={
            classNames(
              '@3xl:sui-pr-8',
              '@7xl:sui-max-w-md',
              'sui-flex-col',
              'sui-flex',
              'sui-gap-4',
              'sui-h-full',
              'sui-pt-4'
            )
          }
        >
          <CardTitle
            header={(
              <Typography
                variant="h2"
                weight="display"
              >
                {cardTitle}
              </Typography>
            )}
          />
          {cardBody}
          {/* eslint-disable-next-line react/no-unknown-property */}
          <div className="sui-flex-end">
            <CardActions>
              <Button variant="secondary" fullWidth href="/c/create-a-quote">
                {learnMoreText}
              </Button>
            </CardActions>
          </div>
        </div>
      </div>
    </Card>
  );
};

CompactNullView.propTypes = nullStatePropTypes;

export default CompactNullView;
